module.exports = __webpack_public_path__ + "img/clothing117.62feac6f.jpg";